import React, { useState, useEffect, useRef } from "react";

const EmojiHappy = () => (
  <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="18" fill="#39B54A" opacity="0.15" />
    <circle cx="18" cy="18" r="15" fill="#39B54A" opacity="0.3" />
    <circle cx="13" cy="15" r="2" fill="#2C2C2C" />
    <circle cx="23" cy="15" r="2" fill="#2C2C2C" />
    <path d="M12 21 Q18 27 24 21" stroke="#2C2C2C" strokeWidth="2" strokeLinecap="round" fill="none" />
  </svg>
);

const EmojiNeutral = () => (
  <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="18" fill="#FFA500" opacity="0.15" />
    <circle cx="18" cy="18" r="15" fill="#FFA500" opacity="0.3" />
    <circle cx="13" cy="15" r="2" fill="#2C2C2C" />
    <circle cx="23" cy="15" r="2" fill="#2C2C2C" />
    <line x1="13" y1="23" x2="23" y2="23" stroke="#2C2C2C" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const EmojiSad = () => (
  <svg width="28" height="28" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="18" fill="#E74C3C" opacity="0.15" />
    <circle cx="18" cy="18" r="15" fill="#E74C3C" opacity="0.3" />
    <circle cx="13" cy="15" r="2" fill="#2C2C2C" />
    <circle cx="23" cy="15" r="2" fill="#2C2C2C" />
    <path d="M12 25 Q18 19 24 25" stroke="#2C2C2C" strokeWidth="2" strokeLinecap="round" fill="none" />
  </svg>
);

const DermaRangeSlider = ({ handleValue }) => {
  const [value, setValue] = useState(0);
  const rangeEl = useRef(null);
  const bubbleEl = useRef(null);
  const emotionEl = useRef(null);

  useEffect(() => {
    if (!rangeEl.current) return;
    const min = Number(rangeEl.current.min);
    const max = Number(rangeEl.current.max);
    const val = Number(rangeEl.current.value);
    const newValue = ((val - min) * 100) / (max - min);
    const newPosition = 10 - newValue * 0.2;

    if (bubbleEl.current) {
      bubbleEl.current.innerHTML = `<span>${val}</span>`;
      bubbleEl.current.style.left = `calc(${newValue}% + (${newPosition}px))`;
    }
    if (emotionEl.current) {
      emotionEl.current.style.left = `calc(${newValue}% + (${newPosition}px))`;
    }

    const colorPct = (val / max) * 100;
    rangeEl.current.style.background = `linear-gradient(to right, #39B54A ${colorPct}%, #CCCCCC ${colorPct}%)`;
  }, [value]);

  const onInput = (e) => {
    const v = Number(e.target.value);
    setValue(v);
    handleValue(v);
  };

  return (
    <div className="drsl-wrap">
      <output ref={bubbleEl} className="drsl-bubble"><span>0</span></output>
      <output ref={emotionEl} className="drsl-emotion">
        {value <= 3 && <EmojiHappy />}
        {value >= 4 && value <= 7 && <EmojiNeutral />}
        {value > 7 && <EmojiSad />}
      </output>
      <input
        ref={rangeEl}
        type="range"
        min="0"
        max="10"
        step="1"
        value={value}
        onInput={onInput}
        onChange={() => {}}
        className="drsl-input"
      />
    </div>
  );
};

export default DermaRangeSlider;
